import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActionDialogComponent, ActionDialogData } from 'src/app/shared/component/action-dialog/action-dialog.component';
import { ImagePreviewData, ImagePreviewDialogComponent } from '../shared/component/image-view-preview-dialog/image-view-preview-dialog.component';
import { ImageViewerData, ImageViewDialogPreviewV2Component } from '../shared/component/image-view-preview-dialog-v2/image-view-preview-dialog-v2.component';

@Injectable({
  providedIn: 'root'
})
export class PopUpDialogService {

  constructor(private md: MatDialog) { }

  // Method 1: Using pre-defined actions
  openCustomActionDialog(config: ActionDialogData) {
    const dialogRef = this.md.open(ActionDialogComponent, {
      width: 'auto',
      maxWidth: 'none',
      panelClass: 'wide-dialog',
      data: config
    });

    return dialogRef.afterClosed();
  }

  // Method 2: Convenience methods for common use cases
  openSuccessDialog(message: string, onClose?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'check_circle',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'OK',
          callback: onClose || (() => {}),
          class: 'flex items-center uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2'
        }
      ]
    });
  }

  openErrorDialog(message: string) {
    return this.openCustomActionDialog({
      dialogIcon: 'error',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'Okay',
          callback: () => {},
          class: 'flex items-center uppercase custom-btn btn-dark-orange font-semibold text-xs px-4 py-2 text-white rounded-lg shadow-md transition duration-300'
        }
      ]
    });
  }

  openInfoActionDialog(message: string, onConfirm: () => void, onCancel?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'info_outline',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'Yes',
          callback: onConfirm,
          class: 'power-btn3 active'
        },
        {
          label: 'No',
          callback: onCancel || (() => {}),
          class: 'power-btn3'
        }
      ]
    });
  }

  openStatusActionDialog(message: string,  actionLabel: string, cancelLabel: string, onConfirm: () => void, onCancel?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'info_outline',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: actionLabel,
          callback: onConfirm,
          class: 'power-btn3 active font-semibold'
        },
        {
          label: cancelLabel,
          callback: onCancel || (() => {}),
          class: 'power-btn3 font-semibold'
        }
      ]
    });
  }

  openRemoveActionDialog(message: string, onConfirm: () => void, onCancel?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'delete_outline',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'Remove',
          callback: onConfirm,
          class: 'power-btn3 active'
        },
        {
          label: 'Cancel',
          callback: onCancel || (() => {}),
          class: 'power-btn3'
        }
      ]
    });
  }

  openSaveActionDialog(message: string, onConfirm: () => void, onCancel?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'save',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'Yes',
          callback: onConfirm,
          class: 'power-btn3 active'
        },
        {
          label: 'Cancel',
          callback: onCancel || (() => {}),
          class: 'power-btn3'
        }
      ]
    });
  }

  openUpdateActionDialog(message: string, onConfirm: () => void, onCancel?: () => void) {
    return this.openCustomActionDialog({
      dialogIcon: 'save',
      description: message,
      enableDisplayAction: true,
      actions: [
        {
          label: 'Save',
          callback: onConfirm,
          class: 'power-btn3 active'
        },
        {
          label: 'Cancel',
          callback: onCancel || (() => {}),
          class: 'power-btn3'
        }
      ]
    });
  }

  openImageViewDialog(imageUrl: string, imageName?: string) {
    const dialogRef = this.md.open(ImagePreviewDialogComponent, {
      width: 'auto',
      maxWidth: '90vw',
      data: {
        imageUrl,
        imageName
      } as ImagePreviewData
    });

    return dialogRef.afterClosed();
  }

  openImagePreviewWithURLDialog(imageUrl: string, title = 'Image URL', imageName?: string) {
    const dialogRef = this.md.open(ImageViewDialogPreviewV2Component, {
      width: '600px',
      maxWidth: '90vw',
      data: { imageUrl, title, imageName } as ImageViewerData,
    });

    return dialogRef.afterClosed();
  }
}
